import BusinessIcon from '@material-ui/icons/Business';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { makeStyles } from '@material-ui/core/styles';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { Theme } from 'enum';
import { useTranslation } from 'react-i18next';
import React from 'react';

const useStyle = makeStyles((theme) => ({
    container: {
        width: '100%',
        padding: theme.spacing(2, 0),
    },
    toggleButtonGroup: {
        width: '100%',
        padding: 0,
        backgroundColor: 'transparent',
        margin: 0,
        '& .MuiToggleButton-root': {
            borderRadius: '8px',
            alignItems: 'center', // Firefox fix
            border: 'none',
        },
        '& .MuiToggleButton-root:first-child': {
            marginRight: '10px',
        },
        '& .MuiToggleButton-root:last-child': {
            marginLeft: '10px',
        },
        '& .MuiToggleButton-label': {
            fontSize: '15px',
        },
        '& .Mui-selected': {
            backgroundColor: '#47bb67',
            color: '#fff',
            border: 'none',
            '&:hover': {
                backgroundColor: '#47bb67',
                color: '#fff',
            },
        },
    },
    toggleButton: {
        transition: '0.3s',
        width: '100%',
        borderRadius: '4px',
        alignItems: 'flex-start',
        color: `${theme.palette.type === Theme.Light ? '#888' : '#eee'}`,
        backgroundColor: `${theme.palette.type === Theme.Light ? '#f2f2f2' : '#424242'}`,
        '&:hover': {
            backgroundColor: `${theme.palette.type === Theme.Light ? '#e4f6e9' : '#373737'}`,
            color: `${theme.palette.type === Theme.Light ? '#289c41' : '#47bb67'}`,
        },
        '& .MuiToggleButton-label': {
            [theme.breakpoints.down('xs')]: {
                fontSize: '14px',
            },
        },
    },
    toggleButtonIcon: {
        marginRight: '10px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '20px',
            marginRight: '5px',
        },
    },
    errorMessage: {
        marginLeft: '14px',
        marginRight: '14px',
    },
}));

type JobTypeProps = {
    jobType: string;
    setJobType: any;
};

export const JobType: React.FC<JobTypeProps> = ({ jobType, setJobType }) => {
    const handleToggle = (_, value) => {
        if (value !== null) {
            setJobType(value);
        }
    };
    const { t } = useTranslation();
    const classes = useStyle();

    return (
        <div className={classes.container}>
            <ToggleButtonGroup
                className={classes.toggleButtonGroup}
                value={jobType}
                onChange={handleToggle}
                exclusive
                aria-label="user-type"
            >
                <ToggleButton value={'jobseeker'} aria-label={'jobseeker'} className={classes.toggleButton}>
                    <PersonOutlineIcon className={classes.toggleButtonIcon} />
                    {t('auth:jobSeeker')}
                </ToggleButton>
                <ToggleButton value={'employer'} aria-label={'employer'} className={classes.toggleButton}>
                    <BusinessIcon className={classes.toggleButtonIcon} />
                    {t('auth:employer')}
                </ToggleButton>
            </ToggleButtonGroup>
        </div>
    );
};
